module.exports = __webpack_public_path__ + "img/icon-twitter-footer.5c2ecff5.svg";